import React from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import addShopperParams from '../../utils/addShopperParams';
import { combineClassNames } from '../../../core/css';
import { getDeepUrl, getBaseUrl, getOrigin } from '../../common/urlBuilder';
import fetchTinyUrl from '../../api/fetchTinyUrl';
import { useModelInfo } from '../../common/ModelInfoContext';

const CallToAction = ({
  cta,
  searchParams,
  showAsButton,
  config,
  postalCode,
  hasInventoryButton,
}) => {
  const { v3ServicesPath } = useModelInfo();
  const { key, label, url } = cta;
  const onRaq = () => {
    const configUrl = getDeepUrl(getBaseUrl(), config, postalCode);
    const baseUrl = getOrigin();

    fetchTinyUrl(v3ServicesPath, configUrl, baseUrl).then((tinyUrl) => {
      const raqUrl =
        key === 'raq' ? addShopperParams(url, searchParams, true) : url;
      const raq = `${raqUrl}&tinyUrl=${tinyUrl}`;
      window.open(raq, '_self');
    });
  };

  const isRaq = key === 'raq' || key === 'gup';
  const Type = isRaq ? 'button' : 'a';
  const raqProps = {
    onClick: onRaq,
    role: 'link',
  };

  return (
    <div
      className={combineClassNames(
        'call-to-action',
        hasInventoryButton ? 'call-to-action__inventory' : ''
      )}>
      <div className={combineClassNames('call-to-action__button')}>
        <Type
          className={'call-to-action__button--primary stat-button-link'}
          data-dtm="next steps"
          href={url}
          {...(isRaq && raqProps)}>
          {label}
        </Type>
      </div>
    </div>
  );
};

const NextStepsLinks = ({
  ctas,
  showAsButton = false,
  config,
  postalCode,
  modelInfo,
  inventoryResult,
}) => {
  const { vsrUrl, isExactMatch, isMatch, vdpUrl } = inventoryResult ?? {};
  const { isCanada } = modelInfo;
  const hasCanadaVsrUrl = isCanada && !!vsrUrl;
  const hasInventoryButton =
    hasCanadaVsrUrl || (isMatch && (vdpUrl || vsrUrl)) || isExactMatch;
  const [searchParams] = useSearchParams();

  const callToActions = ctas.map((cta) => (
    <CallToAction
      key={cta.label}
      cta={cta}
      searchParams={searchParams}
      showAsButton={showAsButton}
      config={config}
      postalCode={postalCode}
      hasInventoryButton={hasInventoryButton}
    />
  ));
  return (
    <div
      className={combineClassNames(
        showAsButton ? 'next-steps-links--button' : 'next-steps-links'
      )}>
      {callToActions}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { config, params } = state;

  return {
    config,
    postalCode: params?.postalCode,
  };
};

export default connect(mapStateToProps)(NextStepsLinks);
